<template>
    <div class="page">
        <Header title="首页" />
        <van-swipe class="swiper" :autoplay="5000" indicator-color="white">
            <van-swipe-item v-for="(item, index) in dataSources.app_banner" :key="index">
                <a :href="item.link" v-if="item.link != ''">
                    <img :src="item.img_url" />
                </a>
                <img :src="item.img_url" v-else />
            </van-swipe-item>
        </van-swipe>
        <div class="card">
            <div class="notice" @click="_onPressToNavigate('', 'message')">
                <img class="img" :src="Images.img_notice" alt="">
                <van-swipe class="notice-swiper" :autoplay="3000" indicator-color="white">
                    <van-swipe-item v-for="(item, index) in dataSources.recent_notice_list" :key="index">
                        <p>{{item.name}}</p>
                    </van-swipe-item>
                </van-swipe>
                <img class="arrow" :src="Images.icon_arrow_right1" alt=""></div>
            <!-- 图标导航 -->
            <div class="nav">
                <div @click="onPressNav(item.url, {category_id: item.id})" v-for="item in dataSources.category_button" :key="item.id">
                    <img :src="item.button_image">
                    <p>{{item.button_name}}</p>
                </div>
            </div>
        </div>
        <div class="line"></div>
        <div class="card">
            <div class="shadow-box" @click="onPressNav('fortune', {id: dataSources.fortune_detail.id, type: 'home'})">
                <div>
                    <div class="calendar">
                        <p>{{dataSources.fortune_detail.date_day}}</p>
                    </div>
                    <div class="date">
                        <p class="date1">
                            {{dataSources.fortune_detail.date_month}}
                            <span>农历{{dataSources.fortune_detail.lunar}}</span>
                        </p>
                        <p class="date2">
                            {{dataSources.fortune_detail.lunarYear}} {{dataSources.fortune_detail.animalsYear}} {{dataSources.fortune_detail.lunar}}
                        </p>
                    </div>
                </div>
                <p class="tip1 text-j">宜：{{dataSources.fortune_detail.suit}}</p>
                <p class="tip2 text-j">忌：{{dataSources.fortune_detail.avoid}}</p>
            </div>
            <!-- 视频 -->
            <div class="video">
                <video :src="dataSources.app_home_video" controls :poster="dataSources.app_home_video_image"></video>
            </div>

            <!-- 分类展示 -->
            <div class="list" v-for="(item, index) in dataSources.content_information" :key="index">
                <img @click="_onPressToWeb(item.url)" class="list-banner" :src="item.image" alt="" v-if="item.image" />
                <div class="list-header">
                    <img :src="Images.icon_home_list_logo2" alt="">
                    <p>{{item.name}}</p>
                    <div @click="onPressNav('article', {category_id: item.id, pageTitle: item.name})">更多 >></div>
                </div>
                <div class="list-body">
                    <reviewItem v-for="(_item, _index) in item.article" :key="_index" :item="_item" :columns="item.columns" />
                </div>
            </div>

            <div class="list">
                <img v-if="dataSources.instructor_banner && dataSources.instructor_banner.image" @click="_onPressToWeb()" class="list-banner" :src="dataSources.instructor_banner.image" />
                <div class="list-header">
                    <img :src="Images.icon_home_list_logo3" alt="">
                    <p>讲师推荐</p>
                    <div @click="_onPressToNavigate('讲师推荐', 'masterUserList', {user_type: Constants.USER_TEACHER})">更多 >></div>
                </div>
                <div class="list-body user-list-wrap">
                    <homeLecturerItem v-for="(item, index) in dataSources.instructor" :user_type="Constants.USER_TEACHER" :key="index" :item="item" />
                </div>
            </div>

            <div v-if="dataSources.inheritor && dataSources.inheritor.length > 0" class="list">
                <img v-if="dataSources.inheritor_banner && dataSources.inheritor_banner.image" @click="_onPressToWeb()" class="list-banner" :src="dataSources.inheritor_banner.image" />
                <div class="list-header">
                    <img :src="Images.icon_home_list_logo4" alt="">
                    <p>传承师推荐</p>
                    <div @click="_onPressToNavigate('传承师推荐', 'masterUserList', {user_type: Constants.USER_MASTER})">更多 >></div>
                </div>
                <div class="list-body user-list-wrap">
                    <homeInheritorItem v-for="(item, index) in dataSources.inheritor" :user_type="Constants.USER_MASTER" :key="index" :item="item" />
                </div>
            </div>

            <div class="wechat">
                <div class="body">
                    <img :src="dataSources.official_account.official_img" alt="">
                    <div>
                        <p class="wechat-title">{{dataSources.official_account.official_title}}</p>
                        <p class="wechat-desc text-line line-2">{{dataSources.official_account.official_content}}</p>
                    </div>
                </div>
                <div class="btn" @click="showQrcode(dataSources.official_account)">关注公众号</div>
            </div>

            <div class="introduce">
                <div class="introduce-item-wrap" v-for="(item, index) in dataSources.enterprise" :key="index">
                    <p>{{item.name}}</p>
                    <img :src="item.cover" alt="" />
                    <span>{{item.overview}}</span>
                </div>
            </div>

            <div v-if="dataSources.recommend_goods && dataSources.recommend_goods.length > 0" class="recommend">
                <div class="header">
                    <img :src="Images.icon_recommend" alt="">
                    <p>精品推荐</p>
                    <div @click="_onPressToNavigate('', 'shop1')">更多 >></div>
                </div>
                <div class="body">
                    <goodsItem v-for="(item, index) in dataSources.recommend_goods" :key="index" :item="item" />
                </div>
            </div>
        </div>
        <Footer :idx="0" />
    </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import homeCourseItem from '@/components/item/homeCourseItem'
import reviewItem from '@/components/item/reviewItem'
import articleItem from '@/components/item/articleItem'
import goodsItem from '@/components/item/goodsItem'
import homeLecturerItem from '@/components/item/homeLecturerItem'
import homeInheritorItem from '@/components/item/homeInheritorItem'
export default {
    components: {
        'Header': Header,
        'Footer': Footer,
        'homeCourseItem': homeCourseItem,
        'reviewItem': reviewItem,
        'articleItem': articleItem,
        'goodsItem': goodsItem,
        'homeLecturerItem': homeLecturerItem,
        'homeInheritorItem': homeInheritorItem,
    },
    data() {
        return {
            isCanAlert: (this.$route.query && this.$route.query.isCanAlert) ? this.$route.query.isCanAlert : 1,
            dataSources: {
                app_banner: [],
                recent_notice_list: [],
                fortune_detail: '',
                app_home_video: '',
                app_home_video_image: '',
                subject: [],
                review: [],
                instructor: [],
                inheritor: [],
                official_account: {
                    official_img: '',
                    official_title: '',
                    official_code: '',
                },
                enterprise: {
                    name: '',
                    cover: '',
                    overview: '',
                },
                recommend_goods: [],
            }
        };
    },
    beforeCreate() {},
    cerated() {},
    beforeMount() {},
    mounted() {
        this.requestData();
        this.requestAlertNoticeDataSources();
    },
    beforeUpdate() {},
    updated() {},
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        // 顶部Nav的跳转
        onPressNav(router, query = {}) {
            if (router === '#') {
                return this.Message({
                    type: 2,
                    title: '温馨提示',
                    content: '内容研发中，敬请期待！',
                    btn: ['关闭']
                })
            } else {
                this.$router.push({
                    path: '/' + router,
                    query: query
                })
            }
        },
        // 请求首页数据
        async requestData() {
            let url = this.API.home_page_index;
            let params = {};
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 公众号二维码
        showQrcode(official_account) {
            this.Message({
                type: 2,
                title: official_account.official_title,
                content: `<img width="120px" height="120px" src="${official_account.official_code}" /><p><span>扫码关注公众号</span></p>`,
                btn: []
            })
        },

        // 请求首页弹窗公告
        async requestAlertNoticeDataSources() {
            console.log('this.isCanAlert---->', this.isCanAlert);
            if (this.isCanAlert && this.isCanAlert > 0) {
                this.timer = setTimeout(() => this._submitRequestAlertNoticeDataSources(this.isCanAlert), 1 * 1000);
            }
        },

        async _submitRequestAlertNoticeDataSources(isCanAlert = 0) {
            let url = this.API.home_notice_alert;
            let data = {
                isCanAlert,
            };
            if (isCanAlert && isCanAlert > 0) {
                let result = await this.$post(url, data);
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    this.notice_alert_temp = result.data;
                    this._dealWithAlertData();
                }
            }
        },

        _dealWithAlertData() {
            let _dataTemp = [...this.notice_alert_temp];
            let _firstItem = _dataTemp[0];
            console.log('_dataTemp1---->', _dataTemp);
            if (_firstItem) {
                this._showNoticeAlert(_firstItem);
                _dataTemp.splice(0,1);
                this.notice_alert_temp = _dataTemp;
                console.log('_dataTemp2---->', _dataTemp);
            }
        },

        _showNoticeAlert(item) {
            let params = {
                title: item.name || '公告信息',
                message: item.content,
                confirmButtonText: '我知道了',
            };
            return this.AlertManager.alert(params).then(() => {
                setTimeout(() => {
                    this._dealWithAlertData();
                    this._onSubmitReadStatus(item);
                }, 200);
            });
        },

        async _onSubmitReadStatus(item) {
            console.log('item---->', item);
            let url = this.API.home_notice_read;
            let data = {
                notice_id: item.id,
            };
            let result = await this.$post(url, data);
        },
    },
    beforeRouteLeave (to, from, next) {
        console.log('to, from', to, from)
        // 设置下一个路由的 meta
        if (to.query.pageTitle) {
            to.meta.title = to.query.pageTitle;
        }
        next();
    }
};
</script>

<style lang="less" scoped>
.page {
    background-color: #fff;
    min-height: 100vh;
}

.swiper {
    height: 50vw;
    overflow: hidden;
    max-height: 39rem;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.card {
    padding: 0 15px 10px;

    .notice {
        height: 35px;
        margin-top: 15px;
        padding: 0 10px;
        border-radius: 3px;
        background: #F8F8F8;
        display: flex;
        align-items: center;

        .img {
            width: 40px;
            height: 18px;
        }

        .notice-swiper {
            flex: 1;
            margin: 0 10px;

            p {
                font-size: 14px;
                color: #333;
            }
        }

        .arrow {
            width: 8px;
            height: 13px;
        }
    }

    .nav {
        display: flex;
        margin-top: 15px;
        align-items: center;
        justify-content: space-around;

        div {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                width: 3rem;
                height: 3rem;
                margin: 0 0 7px;
            }

            p {
                font-size: 14px;
                color: #333;
            }
        }
    }

    .shadow-box {
        margin-top: 1.5rem;
        padding: 1rem 1rem;
        background: #ffffff;
        border-radius: .5rem;
        box-sizing: border-box;
        box-shadow: 0px 0px 5px 0px rgba(191, 190, 190, 0.35);

        img {
            width: 100%;
        }


        > div {
            display: flex;

            img {
                width: 36px;
                height: 40px;
                margin-right: 10px;
            }

            .calendar {
                width: 36px;
                height: 40px;
                margin-right: 10px;
                background-image: url('../../assets/img/img_calendar.png');
                background-size: cover;
                display: flex;
                align-items: center;
                justify-content: center;

                p {
                    margin-top: 5px;
                    font-size: 16px;
                    color: #fff;
                }
            }

            .date {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .date1 {
                    font-size: 16px;
                    color: #333;
                    font-weight: 500;

                    span {
                        font-size: 12px;
                        color: #333;
                        font-weight: 400;
                    }
                }

                .date2 {
                    font-size: 12px;
                    color: #7181EB;
                }
            }
        }

        .tip1 {
            margin-top: 22px;
            font-size: 14px;
            color: #7181EB;
            font-weight: 500;
        }

        .tip2 {
            margin-top: 10px;
            font-size: 14px;
            color: #333;
            font-weight: 500;
        }
    }

    .video {
        overflow: hidden;
        margin-top: 1.5rem;
        border-radius: .5rem;

        video {
            width: 100%;
            object-fit: fill;
            border-radius: .5rem;
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .list {
        margin-top: 15px;
        min-height: 10rem;

        .list-banner {
            width: 100%;
            height: 60px;
            object-fit: cover;
            border-radius: 0.5rem;
        }

        .list-header {
            padding-top: 10px;
            height: 30px;
            display: flex;
            align-items: center;

            img {
                width: 22px;
                height: 20px;
                object-fit: contain;
            }

            p {
                flex: 1;
                margin: 0 10px;
            }

            div {
                height: 20px;
                color: #7181EB;
                padding: 0 1rem;
                line-height: 20px;
                font-size: 1.1rem;
                text-align: center;
                border-radius: 20px;
                border: 1px solid #7181EB;
            }
        }

        .list-body {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
        .user-list-wrap {
            flex-wrap: inherit;
            flex-direction: column;
        }
    }

    .wechat {
        margin-top: 15px;

        .body {
            display: flex;

            img {
                width: 58px;
                height: 58px;
                margin-right: 10px;
            }

            div {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                .wechat-title {
                    font-size: 14px;
                    color: #333;
                    font-weight: 500;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .wechat-desc {
                    color: #666;
                    font-size: 12px;
                    margin-top: 2px;
                }
            }
        }

        .btn {
            margin-top: 10px;
            height: 35px;
            background: linear-gradient(226deg, #9cb2f4, #6472e8 100%);
            border-radius: 3px;
            font-size: 14px;
            color: #fff;
            text-align: center;
            line-height: 35px;
        }
    }

    .introduce {
        margin-top: 15px;

        p {
            font-size: 16px;
            color: #333;
            font-weight: 500;
        }

        img {
            margin-top: 10px;
            width: 100%;
            height: 144px;
            object-fit: cover;
        }

        span {
            color: #333;
            font-size: 13px;
            margin-top: 10px;
            line-height: 1.8;
        }
    }

    .recommend {
        margin-top: 15px;

        .header {
            height: 30px;
            display: flex;
            align-items: center;

            img {
                width: 22px;
                height: 20px;
                object-fit: contain;
            }

            p {
                flex: 1;
                margin: 0 10px;
                font-size: 15px;
                color: #333;
                font-weight: 500;
            }

            div {
                height: 20px;
                color: #7181EB;
                padding: 0 1rem;
                line-height: 20px;
                font-size: 1.1rem;
                text-align: center;
                border-radius: 20px;
                border: 1px solid #7181EB;
            }
        }

        .body {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
}

.line {
    height: 8px;
    width: 100%;
    background: #F8F8F8;
}
</style>